import { useMutation } from 'urql';
import { gql } from 'urql';

export const DELETE_TICKET_MUTATION = gql`
  mutation ($ticketIds: [Int!]) {
    deleteTickets(ticketIds: $ticketIds) {
      success
      rowsAffected
    }
  }
`;

export interface IDeleteTicketVariables {
  ticketIds: number[];
}

export interface IDeleteTicketResponse {
  deleteTickets: {
    success: boolean;
    rowsAffected: number;
  };
}

export const useFetchDeleteTicket = () => {
  const [result, executeMutation] = useMutation<IDeleteTicketResponse, IDeleteTicketVariables>(DELETE_TICKET_MUTATION);
  return { deleteTickets: executeMutation, fetching: result.fetching };
};
